var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLocation = function SvgLocation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.984 27a2.124 2.124 0 0 1-1.915-1.185.906.906 0 0 1-.048-.112l-2.606-7.337a1.278 1.278 0 0 0-.78-.782L2.296 14.98a1.12 1.12 0 0 1-.112-.048A2.127 2.127 0 0 1 1 12.976a2.126 2.126 0 0 1 1.256-1.912l21.712-9.869a2.126 2.126 0 0 1 2.401.435c.638.638.809 1.58.436 2.402l-9.87 21.712A2.126 2.126 0 0 1 15.025 27h-.04Zm-.108-2.048c.019.023.059.059.112.048a.13.13 0 0 0 .128-.084l9.869-21.71c.012-.03.04-.091-.03-.161s-.13-.042-.159-.03l-21.712 9.87a.131.131 0 0 0-.084.128c0 .06.025.092.048.11l7.256 2.577a3.27 3.27 0 0 1 1.996 1.998l2.576 7.254Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;